/* ==========================================================================
   РЕДИЗАЙН DUNE — поведение новых секций
   1. Моушн-галерея в тайле новинок   (sections/dune-new-arrivals.liquid)
   2. Панели подборок: подпись на полосе и перетасовка товаров
                                       (sections/dune-panels.liquid)
   7. Текстовые страницы: чистка текста и «Зміст»
                                       (sections/dune-doc.liquid)
   8. Страница товара: галерея «Сцена» (snippets/dune-product-gallery.liquid)
   9. Цена товара в формате редизайна  (snippets/product-block-header.liquid)
   10. Быстрый просмотр: лента фото    (sections/main-product--quick.liquid)
   11. Стрічка брендів: фото за курсором (sections/dune-brand-belt.liquid)
   11. Виджет связи: панель каналов    (sections/dune-chat.liquid)
   12. Образы: смена образов, слово на направляющих (sections/dune-looks.liquid)
   13. Песок в футере: дымка песчинок и дюна на canvas (sections/dune-footer.liquid)
   14. Кольори в картці: фото кольору при наведенні (snippets/dune-card-colors.liquid)
   15. Кольори на сторінці товару: стрічка або один ряд (snippets/dune-colors.liquid)
   16. Подсказка в поле подписки печатается по буквам (sections/dune-footer.liquid)
   17. Instagram: лента из CRM (sections/dune-instagram.liquid)
   Бегущая строка и конвейер работают на чистом CSS.
   Скрипт подключается один раз из snippets/theme-globals.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var pad3 = function (n) { return (n < 10 ? '00' : n < 100 ? '0' : '') + n; };

  /* --- 1. Моушн-галерея ------------------------------------------------- */

  function initGallery(el) {
    if (el.duneGallery) return;
    el.duneGallery = true;

    var slides = [].slice.call(el.querySelectorAll('.dune-mg__slide'));
    if (!slides.length) return;

    var link = el.querySelector('[data-dune-gallery-link]');
    var eyebrow = el.querySelector('[data-dune-gallery-eyebrow]');
    var title = el.querySelector('[data-dune-gallery-title]');
    var count = el.querySelector('[data-dune-gallery-count]');
    var pct = el.querySelector('[data-dune-gallery-pct]');
    var bar = el.querySelector('[data-dune-gallery-bar]');
    var interval = parseInt(el.getAttribute('data-interval'), 10) || 5000;

    var state = { i: 0, p: 0, busy: false, visible: false, ready: false, hover: false, started: false, last: 0 };

    // Подпись уезжает вверх из-под маски, новая приезжает снизу.
    function swap(node, html, delay) {
      if (!node) return;
      if (reduced) { node.innerHTML = html; return; }
      node.style.transition = 'transform .38s cubic-bezier(.7,0,.84,0)';
      node.style.transform = 'translateY(-120%)';
      setTimeout(function () {
        node.style.transition = 'none';
        node.innerHTML = html;
        node.style.transform = 'translateY(120%)';
        void node.offsetWidth;
        node.style.transition = 'transform .76s cubic-bezier(.16,1,.3,1) ' + (delay || 0) + 'ms';
        node.style.transform = 'translateY(0)';
      }, 400);
    }

    function setProgress(p) {
      if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      if (pct) pct.textContent = pad3(Math.floor(p * 100)) + '%';
    }

    function go(n, dir) {
      var total = slides.length;
      if (state.busy || !state.ready || total < 2) return;
      n = (n + total) % total;
      if (n === state.i) return;

      var from = slides[state.i];
      var to = slides[n];
      state.busy = true;
      state.p = 0;
      setProgress(0);

      swap(eyebrow, to.getAttribute('data-eyebrow') || '', 0);
      swap(title, to.getAttribute('data-title') || '', 90);
      if (link) {
        link.setAttribute('href', to.getAttribute('data-link') || '#');
        link.setAttribute('aria-label', (to.getAttribute('data-title') || '').replace(/<br\s*\/?>/g, ' '));
      }
      if (count) count.textContent = pad(n + 1) + ' / ' + pad(total);

      if (reduced) {
        from.classList.remove('is-current');
        to.classList.add('is-current');
        state.i = n;
        state.busy = false;
        return;
      }

      to.classList.add('is-in');
      from.classList.add('is-out');
      if (dir < 0) { to.classList.add('is-rev'); from.classList.add('is-rev'); }

      setTimeout(function () {
        from.classList.remove('is-current', 'is-out', 'is-rev', 'is-intro');
        to.classList.remove('is-in', 'is-rev');
        to.classList.add('is-current');
        state.i = n;
        state.busy = false;
      }, 1150);
    }

    // Первое появление: фото отъезжает от крупного плана, подпись поднимается.
    function intro() {
      if (state.started) return;
      state.started = true;
      el.classList.add('is-ready');
      if (reduced) { state.ready = true; return; }
      slides[state.i].classList.add('is-intro');
      setTimeout(function () { state.ready = true; }, 700);
      setTimeout(function () { slides.forEach(function (s) { s.classList.remove('is-intro'); }); }, 1800);
    }

    function tick(ts) {
      if (!document.body.contains(el)) return; // секцию перерисовали в редакторе тем
      window.requestAnimationFrame(tick);
      var dt = state.last ? Math.min(100, ts - state.last) : 0;
      state.last = ts;
      if (!state.ready || state.busy || state.hover || !state.visible || document.hidden) return;
      state.p += dt / interval;
      if (state.p >= 1) { go(state.i + 1, 1); return; }
      setProgress(state.p);
    }

    el.addEventListener('mouseenter', function () { state.hover = true; });
    el.addEventListener('mouseleave', function () { state.hover = false; });
    el.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dune-gallery-step]');
      if (!btn) return;
      e.preventDefault();
      var dir = parseInt(btn.getAttribute('data-dune-gallery-step'), 10);
      go(state.i + dir, dir);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          state.visible = entry.isIntersecting;
          if (entry.isIntersecting) intro();
        });
      }, { threshold: 0.3 }).observe(el);
    } else {
      state.visible = true;
      intro();
    }

    if (!reduced && slides.length > 1) window.requestAnimationFrame(tick);
  }

  /* --- 2. Панели подборок ----------------------------------------------- */

  function initPanel(plate) {
    if (plate.dunePanel) return;
    plate.dunePanel = true;

    // Полоса под товарами показывает бренд, название и цену товара под курсором.
    var bar = plate.querySelector('[data-dune-panel-bar]');
    if (bar) {
      var label = bar.querySelector('b');
      var count = bar.querySelector('i');
      var reset = function () {
        label.textContent = bar.getAttribute('data-label') || '';
        count.textContent = bar.getAttribute('data-count') || '';
      };
      plate.addEventListener('mouseover', function (e) {
        var item = e.target.closest('.dune-pnl__item');
        if (!item) { reset(); return; }
        label.textContent = item.getAttribute('data-n') || '';
        count.textContent = item.getAttribute('data-p') || '';
      });
      plate.addEventListener('mouseleave', reset);
    }

    var stage = plate.querySelector('[data-dune-shuffle]');
    if (stage && !reduced) initShuffle(plate, stage);
  }

  // Раз в полторы секунды одна случайная ячейка меняет товар на следующий из запаса.
  function initShuffle(plate, stage) {
    var tpl = stage.querySelector('template[data-dune-pool]');
    if (!tpl) return;

    var describe = function (item) {
      var img = item.querySelector('img');
      return {
        href: item.getAttribute('href'),
        n: item.getAttribute('data-n'),
        p: item.getAttribute('data-p'),
        label: item.getAttribute('aria-label'),
        img: img ? img.outerHTML : ''
      };
    };
    var queue = [].slice.call(tpl.content.querySelectorAll('.dune-pnl__item')).map(describe);
    if (!queue.length) return;

    var lastCell = -1;
    var timer = setInterval(function () {
      if (!document.body.contains(stage)) { clearInterval(timer); return; }
      if (document.hidden || plate.matches(':hover')) return;
      var rect = stage.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;

      var cells = stage.querySelectorAll('.dune-pnl__grid .dune-pnl__item');
      if (!cells.length) return;
      var k;
      do { k = Math.floor(Math.random() * cells.length); } while (k === lastCell && cells.length > 1);
      lastCell = k;

      var cell = cells[k];
      var old = cell.querySelector('img:not(.is-leave)');
      var next = queue.shift();
      queue.push(describe(cell));
      if (!next.img) return;

      var holder = document.createElement('div');
      holder.innerHTML = next.img;
      var img = holder.firstElementChild;
      img.loading = 'eager';
      img.classList.add('is-enter');
      cell.appendChild(img);
      cell.setAttribute('href', next.href);
      cell.setAttribute('data-n', next.n || '');
      cell.setAttribute('data-p', next.p || '');
      cell.setAttribute('aria-label', next.label || '');

      void img.offsetWidth;
      img.classList.remove('is-enter');
      if (old) {
        old.classList.add('is-leave');
        setTimeout(function () { if (old.parentNode) old.parentNode.removeChild(old); }, 750);
      }
    }, 1500);
  }

  /* --- 3. Футер ---------------------------------------------------------- */

  // Элементы с data-dune-reveal получают класс is-in, когда появляются на экране.
  var revealObserver = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.2 })
    : null;

  function initReveal(el) {
    if (el.duneReveal) return;
    el.duneReveal = true;
    if (reduced || !revealObserver) { el.classList.add('is-in'); return; }
    revealObserver.observe(el);
  }

  // На телефоне колонки меню в футере свёрнуты в аккордеон, на компьютере раскрыты.
  var phone = window.matchMedia('(max-width: 760px)');
  function syncFooterFolds() {
    document.querySelectorAll('.dune-ftr__fold').forEach(function (fold) {
      if (phone.matches) fold.removeAttribute('open'); else fold.setAttribute('open', '');
    });
  }
  if (phone.addEventListener) phone.addEventListener('change', syncFooterFolds);

  /* --- 4. Каталог: переключатель колонок --------------------------------- */

  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  // Корень — секция коллекции или блок результатов поиска: у них разные сетка и переменная колонок темы.
  function applyCols(root, n, animate) {
    var search = root.classList.contains('search');
    var grid = root.querySelector(search ? '.search__results' : '.collection__products');
    var set = function () {
      root.style.setProperty(search ? '--search-columns-desktop' : '--collection-columns-desktop', n);
      root.setAttribute('data-dune-density', n);
      root.querySelectorAll('.dune-cols button').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-cols') === String(n));
      });
    };
    if (animate && grid && !reduced) {
      grid.classList.add('is-switching');
      setTimeout(function () { set(); grid.classList.remove('is-switching'); }, 200);
    } else {
      set();
    }
  }

  function initCols(root) {
    if (root.duneCols) return;
    root.duneCols = true;
    var saved = store.get('dune-cols');
    var initial = saved || root.getAttribute('data-dune-cols-default') || root.getAttribute('data-collection-columns-desktop') || '4';
    applyCols(root, initial, false);
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.dune-cols button');
      if (!btn) return;
      e.preventDefault();
      var n = btn.getAttribute('data-cols');
      store.set('dune-cols', n);
      applyCols(root, n, true);
    });
  }

  /* --- 5. Индекс брендов -------------------------------------------------- */

  function initBrandIndex(root) {
    if (root.duneBrands) return;
    root.duneBrands = true;

    var rows = [].slice.call(root.querySelectorAll('.dune-bx__row'));
    var groups = [].slice.call(root.querySelectorAll('[data-dune-brand-group]'));
    var search = root.querySelector('[data-dune-brand-search]');
    var found = root.querySelector('[data-dune-brand-found]');
    var empty = root.querySelector('[data-dune-brand-empty]');
    var preview = root.querySelector('[data-dune-brand-preview]');
    var previewImg = root.querySelector('[data-dune-brand-preview-img]');
    var previewName = root.querySelector('[data-dune-brand-preview-name]');
    var letters = [].slice.call(root.querySelectorAll('[data-dune-brand-letter]'));

    // Поиск: скрывает строки и пустые группы.
    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        var total = 0;
        rows.forEach(function (row) {
          var hit = !q || (row.getAttribute('data-name') || '').indexOf(q) !== -1;
          row.parentNode.hidden = !hit;
          if (hit) total++;
        });
        groups.forEach(function (g) {
          g.hidden = !g.querySelector('li:not([hidden])');
        });
        if (found) found.textContent = q ? '( ' + total + ' )' : '';
        if (empty) empty.hidden = total > 0;
      });
    }

    // Фото бренда справа при наведении на строку.
    if (preview && previewImg) {
      root.addEventListener('mouseover', function (e) {
        var row = e.target.closest('.dune-bx__row');
        if (!row) return;
        var src = row.getAttribute('data-img');
        if (!src) { preview.classList.remove('is-on'); return; }
        if (previewImg.getAttribute('src') !== src) previewImg.setAttribute('src', src);
        if (previewName) previewName.textContent = row.querySelector('.dune-bx__name').textContent;
        preview.classList.add('is-on');
      });
      root.querySelector('.dune-bx__list').addEventListener('mouseleave', function () {
        preview.classList.remove('is-on');
      });
    }

    // Рейка букв подсвечивает текущую группу.
    if ('IntersectionObserver' in window && letters.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          letters.forEach(function (a) { a.classList.toggle('is-current', a.getAttribute('href') === '#' + id); });
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      groups.forEach(function (g) { io.observe(g); });
    }
  }

  // Высота липкой шапки нужна рейке букв, чтобы прилипать под ней.
  function syncStickyTop() {
    var header = document.querySelector('.header');
    var sticky = document.documentElement.classList.contains('sticky-header-enabled');
    var h = header && sticky ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--dune-sticky-top', Math.round(h) + 'px');
  }
  window.addEventListener('resize', syncStickyTop);

  /* --- 6. Контакты: открыто или закрыто ----------------------------------- */

  function initHours(el) {
    if (el.duneHours) return;
    el.duneHours = true;
    var text = el.querySelector('[data-dune-hours-text]');
    var clock = el.querySelector('[data-dune-hours-clock]');
    var toMin = function (s) { var m = /^(\d{1,2}):(\d{2})$/.exec((s || '').trim()); return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null; };
    var open = toMin(el.getAttribute('data-open'));
    var close = toMin(el.getAttribute('data-close'));
    if (open === null || close === null) return;

    var zone = el.getAttribute('data-tz') || 'Europe/Kyiv';
    var now = function () {
      var zones = [zone, 'Europe/Kiev'];
      for (var i = 0; i < zones.length; i++) {
        try {
          var parts = new Intl.DateTimeFormat('en-GB', { timeZone: zones[i], hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date()).split(':');
          return { h: parseInt(parts[0], 10) % 24, m: parseInt(parts[1], 10) };
        } catch (e) {}
      }
      var d = new Date();
      return { h: d.getHours(), m: d.getMinutes() };
    };

    var update = function () {
      var t = now();
      var minutes = t.h * 60 + t.m;
      var isOpen = minutes >= open && minutes < close;
      el.classList.toggle('is-open', isOpen);
      var label = isOpen ? el.getAttribute('data-label-open') : el.getAttribute('data-label-closed');
      var time = isOpen ? el.getAttribute('data-close') : el.getAttribute('data-open');
      if (text && label) text.textContent = label.replace('[time]', time);
      if (clock) clock.textContent = pad(t.h) + ':' + pad(t.m);
    };
    update();
    setInterval(update, 30000);
  }

  /* --- 7. Текстовые страницы ---------------------------------------------- */

  // Текст страниц приходит из админки с мусором от редактора: пустыми абзацами, обёртками,
  // заголовками, набранными жирным абзацем или списком из одного пункта. Приводим его в порядок,
  // выносим номера пунктов («1.1.») в отдельную колонку и собираем «Зміст» из заголовков.
  var docWide = window.matchMedia('(min-width: 901px)');

  function initDoc(root) {
    if (root.duneDoc) return;
    root.duneDoc = true;
    var body = root.querySelector('[data-dune-doc-body]');
    if (!body) return;

    var norm = function (s) { return (s || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); };
    var text = function (el) { return norm(el.textContent); };
    var kids = function () { return [].slice.call(body.children); };
    var isBlock = function (n) { return n.nodeType === 1 && /^(P|DIV|UL|OL|DL|H[1-6]|BLOCKQUOTE|PRE|TABLE|IMG|FIGURE|HR|IFRAME|VIDEO|SECTION|DETAILS|FORM|SCRIPT|STYLE|LINK|NOSCRIPT)$/.test(n.tagName); };
    var hasMedia = function (el) { return !!el.querySelector('img, iframe, video, table, hr'); };
    var noEnd = function (t) { return !/[.;:,!?]$/.test(t); };
    var isCaps = function (t) { return /[A-Za-zА-Яа-яІЇЄҐіїєґ]{3}/.test(t) && t === t.toUpperCase(); };

    // 1. Чистка: служебные теги редактора, стили у текста, обёртки верхнего уровня.
    body.querySelectorAll('meta').forEach(function (m) { m.remove(); });
    body.querySelectorAll('p, div, span, ul, ol, li, strong, b, h1, h2, h3, h4, h5, h6, blockquote').forEach(function (el) {
      el.removeAttribute('style');
    });
    var wrapper;
    while ((wrapper = body.querySelector(':scope > div, :scope > section'))) {
      while (wrapper.firstChild) body.insertBefore(wrapper.firstChild, wrapper);
      wrapper.remove();
    }
    // текст, лежащий прямо в корне, заворачиваем в абзац
    var run = null;
    [].slice.call(body.childNodes).forEach(function (n) {
      if (isBlock(n)) { run = null; return; }
      if (!run) {
        if (n.nodeType === 3 && !norm(n.nodeValue)) return;
        if (n.nodeType === 1 && n.tagName === 'BR') { n.remove(); return; }
        run = document.createElement('p');
        body.insertBefore(run, n);
      }
      run.appendChild(n);
    });
    // пустые элементы, от вложенных к внешним
    [].slice.call(body.querySelectorAll('p, li, ul, ol, blockquote, h1, h2, h3, h4, h5, h6')).reverse().forEach(function (el) {
      if (!text(el) && !hasMedia(el)) el.remove();
    });

    // 2. Заголовки, набранные не заголовками.
    var heading = function (el, tag, label, n) {
      var h = document.createElement(tag);
      h.textContent = label;
      if (n) h.setAttribute('data-n', n);
      el.parentNode.replaceChild(h, el);
      return h;
    };
    // весь текст элемента набран жирным
    var allBold = function (el) {
      var bold = '';
      el.querySelectorAll('strong, b').forEach(function (s) {
        var up = s.parentElement.closest('strong, b');
        if (!up || !el.contains(up)) bold += s.textContent;
      });
      return norm(bold).length >= text(el).length;
    };

    kids().forEach(function (el) {
      var t = text(el);
      if (el.tagName === 'P' && !el.querySelector('br') && !hasMedia(el)) {
        var num = /^(\d{1,2})[.)]{1,2}\s+(.+)$/.exec(t);
        if (num && !/^\d+\.\d/.test(t) && t.length <= 160 && noEnd(t)) {
          heading(el, 'h3', num[2], num[1]);                        // «1. Загальні положення»
        } else if (isCaps(t) && t.length <= 80 && noEnd(t)) {
          heading(el, 'h2', t);                                     // «ДОГОВІР ПУБЛІЧНОЇ ОФЕРТИ»
        } else if (allBold(el)) {
          if (t.length <= 120 && noEnd(t)) heading(el, 'h3', t);    // жирная строка-заголовок
          else if (/[.!]$/.test(t)) el.classList.add('dune-rte__note');
        } else if (t.length <= 30 && /^[A-ZА-ЯІЇЄҐ][^.,:;!?\d]+$/.test(t) && el.nextElementSibling && /^(P|UL|OL)$/.test(el.nextElementSibling.tagName)) {
          heading(el, 'h3', t);                                     // короткая строка без знаков перед абзацем
        }
        return;
      }
      // список из одного пункта, начинающегося с жирного: это заголовок способа оплаты и т. п.
      if (el.tagName === 'UL' && el.children.length === 1) {
        var li = el.children[0];
        var nodes = [].slice.call(li.childNodes).filter(function (n) { return n.nodeType !== 3 || norm(n.nodeValue); });
        var title = '';
        while (nodes.length && nodes[0].nodeType === 1 && /^(STRONG|B)$/.test(nodes[0].tagName)) title += nodes.shift().textContent;
        title = norm(title).replace(/\s*:$/, '');
        if (!title || title.length > 120) return;
        var rest = null;
        if (nodes.length) {
          rest = document.createElement('p');
          nodes.forEach(function (n) { rest.appendChild(n); });
          rest.innerHTML = rest.innerHTML.replace(/^\s*:\s*/, '');
        }
        var h = heading(el, 'h3', title);
        if (rest && text(rest)) h.parentNode.insertBefore(rest, h.nextSibling);
      }
    });

    // первый заголовок, повторяющий название страницы, лишний
    var h1 = root.querySelector('h1');
    var first = body.firstElementChild;
    if (h1 && first && !first.hasAttribute('data-dune-doc-own') && /^H[1-3]$/.test(first.tagName) && text(first).toLowerCase() === text(h1).toLowerCase()) first.remove();

    // раздел, который секция выводит сама (способы оплаты), в тексте из админки повторяется: копию убираем
    body.querySelectorAll(':scope > [data-dune-doc-own]').forEach(function (own) {
      var name = text(own).toLowerCase();
      kids().forEach(function (el) {
        if (el === own || el.tagName !== 'H2' || text(el).toLowerCase() !== name) return;
        var next;
        while ((next = el.nextElementSibling) && next.tagName !== 'H2') next.remove();
        el.remove();
      });
    });

    // собственное «Зміст» автора убираем: рейка собирает своё
    kids().forEach(function (el) {
      if (!/^H[2-4]$/.test(el.tagName) || !/^(зміст|содержание|contents)$/i.test(text(el))) return;
      var next = el.nextElementSibling;
      if (next && /^(OL|UL)$/.test(next.tagName)) next.remove();
      el.remove();
    });

    // 3. Номера пунктов: «1.1.», «8.2.1.», «3.» и «а)» уходят в левую колонку.
    body.querySelectorAll(':scope > p').forEach(function (p) {
      var walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) { if (norm(node.nodeValue)) break; }
      if (!node) return;
      var m = /^\s*(\d{1,2}(?:\.\d{1,2})+\.?(?=\s|[^\d\s.,])|\d{1,2}\.(?=\s)|[а-яіїєґ]\)(?=\s))\s*/i.exec(node.nodeValue.replace(/ /g, ' '));
      if (!m || text(p).indexOf(norm(m[1])) !== 0) return;
      var tail = node.splitText(m[0].length);
      var n = document.createElement('span');
      n.className = 'dune-rte__n';
      n.textContent = m[1];
      node.parentNode.replaceChild(n, node);
      if (tail.parentNode !== p) p.insertBefore(n, p.firstChild);
      p.classList.add('dune-rte__clause');
    });

    // длинный заголовок-название документа набираем мельче
    body.querySelectorAll('h1, h2').forEach(function (h) { if (text(h).length > 60) h.classList.add('is-long'); });

    body.querySelectorAll('table').forEach(function (table) {
      var scroll = document.createElement('div');
      scroll.className = 'dune-rte__scroll';
      table.parentNode.insertBefore(scroll, table);
      scroll.appendChild(table);
    });

    // на телефоне соседние страницы идут лентой: текущая должна быть видна
    var current = root.querySelector('.dune-doc__nav a.is-active');
    if (current) {
      var strip = current.closest('ol');
      if (strip.scrollWidth > strip.clientWidth) strip.scrollLeft = current.parentNode.offsetLeft - strip.offsetLeft - 16;
    }

    // 4. «Зміст». Если разделов-h2 меньше двух, главными считаем h3.
    var toc = root.querySelector('[data-dune-doc-toc]');
    var list = toc && toc.querySelector('ol');
    var heads = [].slice.call(body.querySelectorAll(':scope > h2, :scope > h3, :scope > .dune-methods h3'));
    var deep = heads.filter(function (h) { return h.tagName === 'H2'; }).length >= 2;
    var items = heads.filter(function (h) { return deep || h.tagName === 'H3'; });
    var links = [];
    var seq = 0;

    items.forEach(function (h, i) {
      var sub = deep && h.tagName === 'H3';
      var own = /^(\d{1,2})\.\s+(.+)$/.exec(text(h));
      if (own && !h.getAttribute('data-n')) { h.textContent = own[2]; h.setAttribute('data-n', own[1]); }
      var n = h.getAttribute('data-n');
      if (!sub) seq += 1;
      var idx = n ? pad(parseInt(n, 10)) : (sub ? '' : pad(seq));
      var label = text(h);
      h.id = 'dune-s-' + (i + 1);
      if (idx) {
        var mark = document.createElement('span');
        mark.className = 'dune-rte__idx';
        mark.textContent = idx;
        h.insertBefore(mark, h.firstChild);
      }
      if (!list) return;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      if (sub) li.className = 'is-sub';
      else { var num = document.createElement('i'); num.textContent = idx; a.appendChild(num); }
      var span = document.createElement('span');
      span.textContent = label;
      a.appendChild(span);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (!docWide.matches) toc.removeAttribute('open');
        h.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        if (window.history.replaceState) window.history.replaceState(null, '', '#' + h.id);
      });
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });

    if (!toc || items.length < 3) return;
    toc.hidden = false;
    var count = toc.querySelector('[data-dune-doc-toc-count]');
    if (count) count.textContent = '( ' + items.filter(function (h) { return !(deep && h.tagName === 'H3'); }).length + ' )';

    // на компьютере «Зміст» раскрыт всегда, на телефоне сложен в строку
    var syncToc = function () { if (docWide.matches) toc.setAttribute('open', ''); else toc.removeAttribute('open'); };
    syncToc();
    if (docWide.addEventListener) docWide.addEventListener('change', syncToc);

    // подсветка текущего раздела: последний заголовок, который уже ушёл под шапку
    var ticking = false;
    var spy = function () {
      ticking = false;
      var line = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--dune-sticky-top'), 10) || 64) + 80;
      var at = -1;
      items.forEach(function (h, i) { if (h.getBoundingClientRect().top <= line) at = i; });
      links.forEach(function (a, i) { a.classList.toggle('is-active', i === at); });
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(spy);
    }, { passive: true });
    spy();

    if (window.location.hash && /^#dune-s-\d+$/.test(window.location.hash)) {
      var target = document.getElementById(window.location.hash.slice(1));
      if (target) target.scrollIntoView();
    }
  }

  /* --- 8. Страница товара: галерея «Сцена» --------------------------------- */

  var stagePhone = window.matchMedia('(max-width: 959px)');
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var PER_PAGE = 4; // фото на странице галереи: два ряда по два

  // Просмотр на весь экран: один на страницу, создаётся при первом открытии.
  var lightbox = null;
  function getLightbox() {
    if (lightbox) return lightbox;
    var el = document.createElement('div');
    el.className = 'dune-lb';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Перегляд фото');
    el.innerHTML =
      '<div class="dune-lb__scroll"><img alt=""></div>' +
      '<button type="button" class="dune-lb__btn dune-lb__close">Закрити</button>' +
      '<button type="button" class="dune-lb__btn dune-lb__prev" aria-label="Попереднє фото">←</button>' +
      '<button type="button" class="dune-lb__btn dune-lb__next" aria-label="Наступне фото">→</button>' +
      '<span class="dune-lb__count"></span>';
    document.body.appendChild(el);

    lightbox = {
      el: el,
      scroll: el.querySelector('.dune-lb__scroll'),
      img: el.querySelector('img'),
      count: el.querySelector('.dune-lb__count'),
      close: el.querySelector('.dune-lb__close'),
      items: [],
      index: 0,
      opener: null,
      ratio: 0.8,
      zoomed: false
    };
    var LB_ZOOM = 2.2;
    var scroll = lightbox.scroll;
    var img = lightbox.img;

    // Фото целиком вписано в экран; нажатие увеличивает его, второе возвращает.
    function layout() {
      var vw = scroll.clientWidth;
      var vh = scroll.clientHeight;
      var w = Math.min(vw, vh * lightbox.ratio);
      if (lightbox.zoomed) w *= LB_ZOOM;
      img.style.width = Math.round(w) + 'px';
      img.style.height = Math.round(w / lightbox.ratio) + 'px';
    }
    // увеличенное фото на компьютере ходит за курсором: край экрана = край фото
    function pan(x, y) {
      var r = scroll.getBoundingClientRect();
      scroll.scrollLeft = (x - r.left) / r.width * (scroll.scrollWidth - scroll.clientWidth);
      scroll.scrollTop = (y - r.top) / r.height * (scroll.scrollHeight - scroll.clientHeight);
    }
    function setZoom(on, e) {
      var ir = img.getBoundingClientRect();
      var fx = e ? (e.clientX - ir.left) / ir.width : 0.5;
      var fy = e ? (e.clientY - ir.top) / ir.height : 0.5;
      lightbox.zoomed = on;
      el.classList.toggle('is-zoom', on);
      layout();
      if (!on) return;
      if (hoverable && e) { pan(e.clientX, e.clientY); return; }
      // на телефоне точка нажатия остаётся под пальцем
      var sr = scroll.getBoundingClientRect();
      var px = e ? e.clientX - sr.left : scroll.clientWidth / 2;
      var py = e ? e.clientY - sr.top : scroll.clientHeight / 2;
      scroll.scrollLeft = fx * img.offsetWidth - px;
      scroll.scrollTop = fy * img.offsetHeight - py;
    }

    lightbox.show = function (i) {
      var n = lightbox.items.length;
      if (!n) return;
      lightbox.index = (i + n) % n;
      var item = lightbox.items[lightbox.index];
      var thumb = item.querySelector('img');
      var full = item.getAttribute('data-full');
      lightbox.ratio = thumb && thumb.naturalWidth ? thumb.naturalWidth / thumb.naturalHeight
        : parseFloat(getComputedStyle(item).getPropertyValue('--dune-gal-ar')) || 0.8;
      lightbox.zoomed = false;
      el.classList.remove('is-zoom');
      // пока грузится крупная картинка, видна уже загруженная из галереи
      var shown = thumb && thumb.currentSrc;
      img.src = shown || full;
      img.alt = thumb ? thumb.alt : '';
      if (shown && shown !== full) {
        var big = new Image();
        big.onload = function () { if (lightbox.items[lightbox.index] === item) img.src = full; };
        big.src = full;
      }
      lightbox.count.textContent = pad(lightbox.index + 1) + ' / ' + pad(n);
      el.classList.toggle('dune-lb--one', n < 2);
      layout();
      scroll.scrollTop = 0;
      scroll.scrollLeft = 0;
    };
    lightbox.hide = function () {
      el.hidden = true;
      document.documentElement.style.overflow = '';
      if (lightbox.opener) lightbox.opener.focus();
    };
    lightbox.layout = layout;
    scroll.addEventListener('click', function (e) {
      if (lightbox.zoomed) setZoom(false);
      else if (e.target === img) setZoom(true, e);
      else lightbox.hide();
    });
    if (hoverable) {
      scroll.addEventListener('mousemove', function (e) {
        if (lightbox.zoomed) pan(e.clientX, e.clientY);
      }, { passive: true });
    }
    window.addEventListener('resize', function () { if (!el.hidden) layout(); });
    lightbox.close.addEventListener('click', lightbox.hide);
    el.querySelector('.dune-lb__prev').addEventListener('click', function () { lightbox.show(lightbox.index - 1); });
    el.querySelector('.dune-lb__next').addEventListener('click', function () { lightbox.show(lightbox.index + 1); });
    return lightbox;
  }

  function playClip(clip) {
    var p = clip.play();
    if (p && p.catch) p.catch(function () {});
  }

  function initStage(el) {
    if (el.duneStage) return;
    el.duneStage = true;

    var frame = el.querySelector('[data-dune-stage-frame]');
    var track = el.querySelector('[data-dune-stage-track]');
    var pages = [].slice.call(el.querySelectorAll('.dune-gal__page'));
    var items = [].slice.call(el.querySelectorAll('[data-dune-stage-item]'));
    var photos = items.filter(function (item) { return item.hasAttribute('data-full'); });
    var thumbs = [].slice.call(el.querySelectorAll('[data-dune-stage-thumb]'));
    var count = el.querySelector('[data-dune-stage-count]');
    var mcount = el.querySelector('[data-dune-stage-mcount]');
    if (!frame || !track || !items.length) return;
    var page = 0;

    function setPage(p) {
      page = Math.min(pages.length - 1, Math.max(0, p));
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.style.transform = 'translateX(-' + (page * (frame.clientWidth + gap)) + 'px)';
      var from = page * PER_PAGE;
      var to = Math.min(items.length, from + PER_PAGE);
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k >= from && k < to); });
      if (count) count.textContent = pad(from + 1) + (to > from + 1 ? '–' + pad(to) : '') + ' / ' + pad(items.length);
    }
    function step(dir) {
      if (dir > 0) setPage(page >= pages.length - 1 ? 0 : page + 1);
      else setPage(page <= 0 ? pages.length - 1 : page - 1);
    }
    el.duneStageStep = step;

    el.addEventListener('click', function (e) {
      var t = e.target.closest('[data-dune-stage-step]');
      if (t) { step(parseInt(t.getAttribute('data-dune-stage-step'), 10)); return; }
      t = e.target.closest('[data-dune-stage-thumb]');
      if (t) { setPage(Math.floor(parseInt(t.getAttribute('data-dune-stage-thumb'), 10) / PER_PAGE)); return; }
      t = e.target.closest('[data-dune-stage-item]');
      if (t && photos.indexOf(t) > -1) {
        var lb = getLightbox();
        lb.items = photos;
        lb.opener = t;
        lb.el.hidden = false;
        lb.show(photos.indexOf(t));
        document.documentElement.style.overflow = 'hidden';
        lb.close.focus();
        return;
      }
      // если браузер не дал видео запуститься самому (режим экономии), оно стартует по нажатию
      var clip = t && t.querySelector('video');
      if (clip && clip.paused) playClip(clip);
    });

    // видео идёт как анимация: без панели, играет, пока его видно
    var clips = [].slice.call(el.querySelectorAll('.dune-gal__item--media video'));
    if (clips.length && 'IntersectionObserver' in window) {
      var clipWatch = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) playClip(entry.target);
          else entry.target.pause();
        });
      }, { threshold: 0.25 });
      clips.forEach(function (clip) { clipWatch.observe(clip); });
    }

    // лупа: фото увеличивается под курсором. Крупную картинку подгружаем при первом наведении.
    if (hoverable) {
      frame.addEventListener('mousemove', function (e) {
        var item = stagePhone.matches ? null : e.target.closest('[data-dune-stage-item]');
        if (item && photos.indexOf(item) < 0) item = null;
        items.forEach(function (x) { if (x !== item) x.classList.remove('is-zoom'); });
        if (!item) return;
        if (!item.duneBig) {
          item.duneBig = true;
          var img = item.querySelector('img');
          if (img) img.sizes = '70vw';
        }
        var r = item.getBoundingClientRect();
        item.style.setProperty('--dune-zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        item.style.setProperty('--dune-zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        item.classList.add('is-zoom');
      }, { passive: true });
      frame.addEventListener('mouseleave', function () {
        items.forEach(function (x) { x.classList.remove('is-zoom'); });
      });
    }

    // на телефоне фото листаются пальцем: счётчик и линия под ними
    track.addEventListener('scroll', function () {
      if (!mcount) return;
      var w = items[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      var k = Math.min(items.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
      mcount.textContent = (k + 1) + ' / ' + items.length;
      el.style.setProperty('--dune-gal-k', k);
    }, { passive: true });

    window.addEventListener('resize', function () { setPage(page); });
    setPage(0);
  }

  document.addEventListener('keydown', function (e) {
    if (lightbox && !lightbox.el.hidden) {
      if (e.key === 'Escape') lightbox.hide();
      if (e.key === 'ArrowRight') lightbox.show(lightbox.index + 1);
      if (e.key === 'ArrowLeft') lightbox.show(lightbox.index - 1);
      return;
    }
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    if (/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName) || e.target.isContentEditable) return;
    if (document.body.getAttribute('data-fluorescent-overlay-open') === 'true') return;
    var stage = document.querySelector('[data-dune-stage]');
    if (!stage || !stage.duneStageStep || stagePhone.matches) return;
    var r = stage.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) return;
    stage.duneStageStep(e.key === 'ArrowRight' ? 1 : -1);
  });

  /* --- 9. Цена товара в формате редизайна ----------------------------------- */

  // «17 941 ₴»: без копеек, тонкий пробел между разрядами. То же делает snippets/dune-money.liquid.
  function duneMoney(cents, symbol) {
    var whole = Math.floor(cents / 100);
    var rest = cents % 100;
    var s = String(whole).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    if (rest) s += ',' + pad(rest);
    return s + ' ' + symbol;
  }

  // При смене размера тема переписывает цены в своём формате («₴17,941.00»).
  // Берём цены выбранного варианта из data-dune-variants и возвращаем наш формат.
  function syncPrices(root) {
    var box = root.querySelector('[data-dune-prices]');
    var data = box && box.querySelector('[data-dune-variants]');
    var select = root.querySelector('[data-variant-select]');
    if (!data || !select) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var id = parseInt(select.value, 10);
    var variant = variants.filter(function (v) { return v.id === id; })[0];
    var off = box.querySelector('[data-dune-off]');
    var typed = root.querySelector('[data-price-display-type]');
    if (!variant || (typed && typed.getAttribute('data-price-display-type') !== 'price')) {
      if (off) off.textContent = '';
      return;
    }
    var symbol = box.getAttribute('data-currency') || '₴';
    var sale = variant.c > variant.p;
    root.querySelectorAll('[data-price]').forEach(function (node) { node.textContent = duneMoney(variant.p, symbol); });
    root.querySelectorAll('[data-compare-price]').forEach(function (node) { node.textContent = sale ? duneMoney(variant.c, symbol) : ''; });
    if (off) off.textContent = sale ? '−' + Math.round((variant.c - variant.p) * 100 / variant.c) + '%' : '';
  }
  function schedulePrices(e) {
    var root = e.target.closest ? e.target.closest('[data-section-type="product"], [data-is-quick-view]') : null;
    if (!root || !root.querySelector('[data-dune-prices]')) return;
    // тема обновляет цену в своём обработчике: наш проход должен идти после него
    setTimeout(function () { syncPrices(root); }, 0);
    setTimeout(function () { syncPrices(root); }, 120);
  }
  document.addEventListener('change', schedulePrices, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-option-buttons]')) schedulePrices(e);
  }, true);

  /* --- 10. Быстрый просмотр: лента фото -------------------------------------- */

  // Окно тема подгружает уже после загрузки страницы, поэтому события ловим на документе.
  function qvState(track) {
    var slides = track.children;
    var step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
    return { n: slides.length, step: step, i: step ? Math.round(track.scrollLeft / step) : 0 };
  }
  function qvStep(box, dir) {
    var track = box.querySelector('[data-dune-qv-track]');
    if (!track) return;
    var st = qvState(track);
    var i = Math.max(0, Math.min(st.n - 1, st.i + dir));
    track.scrollTo({ left: i * st.step, behavior: reduced ? 'auto' : 'smooth' });
  }
  // счётчик, линия прогресса и стрелки следуют за прокруткой: пальцем лента листается без кнопок
  function qvSync(track) {
    var box = track.closest('[data-dune-qv]');
    if (!box) return;
    var st = qvState(track);
    box.style.setProperty('--dune-qv-k', st.i);
    var now = box.querySelector('[data-dune-qv-now]');
    if (now) now.textContent = pad(st.i + 1);
    box.querySelectorAll('[data-dune-qv-step]').forEach(function (btn) {
      var dir = parseInt(btn.getAttribute('data-dune-qv-step'), 10);
      btn.setAttribute('aria-disabled', dir < 0 ? st.i <= 0 : st.i >= st.n - 1);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-dune-qv-step]') : null;
    if (btn) qvStep(btn.closest('[data-dune-qv]'), parseInt(btn.getAttribute('data-dune-qv-step'), 10));
  });
  // scroll не всплывает, но доходит до документа на фазе перехвата
  document.addEventListener('scroll', function (e) {
    if (e.target.matches && e.target.matches('[data-dune-qv-track]')) qvSync(e.target);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    if (/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
    var box = document.querySelector('[data-quick-view-modal].is-visible [data-dune-qv]');
    if (box) qvStep(box, e.key === 'ArrowRight' ? 1 : -1);
  });

  /* --- 11. Виджет связи --------------------------------------------------- */

  // Панель открывается кнопкой, закрывается ею же, клавишей Esc и кликом мимо виджета.
  function chatSet(el, open) {
    var btn = el.querySelector('[data-dune-chat-toggle]');
    el.classList.toggle('is-expanded', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-dune-chat-toggle]') : null;
    document.querySelectorAll('[data-dune-chat]').forEach(function (el) {
      if (btn && el.contains(btn)) chatSet(el, !el.classList.contains('is-expanded'));
      else if (!el.contains(e.target)) chatSet(el, false);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-dune-chat].is-expanded').forEach(function (el) {
      var btn = el.querySelector('[data-dune-chat-toggle]');
      if (btn && el.contains(document.activeElement)) btn.focus();
      chatSet(el, false);
    });
  });
  // В редакторе тем панель раскрыта, пока выбрана секция или её канал.
  ['shopify:section:select', 'shopify:section:deselect', 'shopify:block:select'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var el = e.target.matches('[data-dune-chat]') ? e.target : e.target.querySelector('[data-dune-chat]') || e.target.closest('[data-dune-chat]');
      if (el) chatSet(el, name !== 'shopify:section:deselect');
    });
  });

  // У нижней строки футера виджет не закрывает копирайт и оплату: строка выталкивает его вверх.
  var chatQueued = false;
  function syncChatLift() {
    chatQueued = false;
    var base = document.querySelector('.dune-ftr__bottom');
    var lift = base ? Math.max(0, Math.round(window.innerHeight - base.getBoundingClientRect().top)) : 0;
    // Ярлык подписки слева стоит на одном уровне с чатом — поднимается вместе с ним.
    document.querySelectorAll('.dune-chat, .dune-signup__tab').forEach(function (el) {
      el.style.setProperty('--dune-chat-lift', lift + 'px');
    });
  }
  function queueChatLift() {
    if (chatQueued) return;
    chatQueued = true;
    requestAnimationFrame(syncChatLift);
  }
  window.addEventListener('scroll', queueChatLift, { passive: true });
  window.addEventListener('resize', queueChatLift);

  // Окно самовывоза берёт название товара из атрибута, который ставит скрипт темы (полное,
  // с брендом). Перед открытием подменяем его названием со страницы: оно уже очищено.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-store-availability-drawer-trigger]') : null;
    if (!trigger) return;
    var box = trigger.closest('[data-store-availability-container]');
    var root = trigger.closest('[data-section-type="product"]');
    var title = root && root.querySelector('.product__title');
    if (box && title) box.setAttribute('data-product-title', title.textContent.trim());
  }, true);

  /* --- 11. Стрічка брендів: фото бренда при наведении ------------------------ */

  // Два слоя <img>: новое фото грузится в скрытый слой и проявляется, когда готово.
  // В режиме «за курсором» фото стоит на линии над рядами и догоняет курсор по горизонтали.
  function initBrandBelt(root) {
    if (root.duneBelt) return;
    root.duneBelt = true;
    var body = root.querySelector('[data-dune-bb-body]');
    var pic = root.querySelector('[data-dune-bb-pic]');
    var mode = root.getAttribute('data-dune-bb-photo');
    if (!body || !pic || mode === 'none' || !hoverable) return;

    var imgs = pic.querySelectorAll('img');
    var name = pic.querySelector('[data-dune-bb-name]');
    var live = 0;
    var current = imgs[0].getAttribute('src') || '';

    var x = 0, tx = 0, raf = 0;
    var ease = reduced ? 1 : 0.16;
    function step() {
      x += (tx - x) * ease;
      pic.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      raf = Math.abs(tx - x) > 0.3 ? requestAnimationFrame(step) : 0;
    }
    // Целевая точка: центр фото под курсором, в пределах ряда. Заголовок слева и ссылку
    // справа фото обходит, если для этого хватает места.
    var head = root.querySelector('.dune-bb__head');
    var title = head && head.firstElementChild;
    var link = head && head.querySelector('.dune-sec__link');
    function aim(e) {
      var r = body.getBoundingClientRect();
      var w = pic.offsetWidth;
      var min = 0, max = r.width - w;
      if (title) min = Math.min(max, title.getBoundingClientRect().right - r.left + 24);
      if (link) max = Math.max(min, link.getBoundingClientRect().left - r.left - 24 - w);
      tx = Math.max(min, Math.min(max, e.clientX - r.left - w / 2));
      if (!raf) raf = requestAnimationFrame(step);
    }

    function show(chip, e) {
      var src = chip.getAttribute('data-img');
      if (!src) { if (mode === 'cursor') pic.classList.remove('is-on'); return; }
      if (name) name.textContent = chip.getAttribute('data-name') || '';
      if (mode === 'cursor') {
        // появление сразу под курсором, без разбега через весь экран
        if (!pic.classList.contains('is-on') && e) { aim(e); x = tx; }
        pic.classList.add('is-on');
      }
      if (src === current) return;
      current = src;
      var next = imgs[1 - live];
      next.src = src;
      var swap = function () {
        if (current !== src) return;
        imgs[live].classList.remove('is-live');
        next.classList.add('is-live');
        live = 1 - live;
      };
      if (next.decode) next.decode().then(swap, swap); else swap();
    }

    root.addEventListener('mouseover', function (e) {
      var chip = e.target.closest('.dune-bb__chip');
      if (chip) show(chip, e);
    });
    root.addEventListener('focusin', function (e) {
      var chip = e.target.closest('.dune-bb__chip');
      if (chip) show(chip);
    });
    if (mode === 'cursor') {
      body.addEventListener('mousemove', aim);
      body.addEventListener('mouseleave', function () { pic.classList.remove('is-on'); });
    }
  }

  /* --- 12. Образы: смена образов и слово на направляющих ---------------- */

  // Меряет высоту прописных у реально загруженного шрифта и поджимает строку так,
  // чтобы буквы стояли на нижней линии и касались верхней. Выносные элементы (Й, Ї, Щ, Д)
  // выходят за линии, как и положено.
  function fitTitle(el) {
    var apply = function () {
      var cs = window.getComputedStyle(el);
      var ctx = document.createElement('canvas').getContext('2d');
      ctx.font = cs.fontWeight + ' 200px ' + cs.fontFamily;
      var cap = ctx.measureText('Н');
      var text = ctx.measureText((el.textContent || '').trim().toUpperCase());
      if (!cap.fontBoundingBoxAscent) return;
      var fa = cap.fontBoundingBoxAscent / 200;
      var fd = cap.fontBoundingBoxDescent / 200;
      var base = (1 - (fa + fd)) / 2 + fa;
      el.style.lineHeight = '1';
      el.style.marginTop = (-(base - cap.actualBoundingBoxAscent / 200)).toFixed(4) + 'em';
      el.style.marginBottom = (-(1 - base)).toFixed(4) + 'em';
      el.style.marginLeft = (text.actualBoundingBoxLeft / 200).toFixed(4) + 'em';
    };
    if (document.fonts && document.fonts.load) {
      var cs = window.getComputedStyle(el);
      document.fonts.load(cs.fontWeight + ' 100px ' + cs.fontFamily, el.textContent).then(apply, apply);
    } else {
      apply();
    }
  }

  function initLooks(root) {
    if (root.dataset.duneLooksReady) return;
    root.dataset.duneLooksReady = '1';
    var sets = root.querySelectorAll('[data-look]');
    var specs = root.querySelectorAll('[data-look-spec]');
    var progress = root.querySelector('[data-look-progress]');
    var num = root.querySelector('[data-look-n]');
    var name = root.querySelector('[data-look-name]');
    var stage = root.querySelector('[data-look-stage]');
    var auto = root.hasAttribute('data-autoplay') && !reduced && sets.length > 1;
    var cur = 0;
    if (!sets.length) return;

    function run() {
      if (!auto || !progress) return;
      progress.classList.remove('is-run');
      void progress.offsetWidth;
      progress.classList.add('is-run');
    }
    function show(i) {
      cur = (i + sets.length) % sets.length;
      sets.forEach(function (el, k) {
        el.classList.toggle('is-on', k === cur);
        if (k === cur) el.removeAttribute('inert'); else el.setAttribute('inert', '');
      });
      specs.forEach(function (el, k) { el.classList.toggle('is-on', k === cur); });
      if (num) num.textContent = pad(cur + 1);
      if (name) name.textContent = sets[cur].dataset.name || '';
      run();
    }

    var prev = root.querySelector('[data-look-prev]');
    var next = root.querySelector('[data-look-next]');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    if (progress) progress.addEventListener('animationend', function () { show(cur + 1); });
    if (stage) {
      stage.addEventListener('mouseenter', function () { root.classList.add('is-paused'); });
      stage.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); });
      stage.addEventListener('focusin', function () { root.classList.add('is-paused'); });
      stage.addEventListener('focusout', function () { root.classList.remove('is-paused'); });
    }
    // Отсчёт идёт, только пока блок на экране: посетитель всегда начинает с первого образа.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        root.classList.toggle('is-live', entries[0].isIntersecting);
      }, { threshold: 0.35 }).observe(root);
    } else {
      root.classList.add('is-live');
    }
    // В редакторе тем выбранный блок-образ сразу показывается.
    root.addEventListener('shopify:block:select', function (e) {
      sets.forEach(function (el, k) { if (el === e.target) show(k); });
      root.classList.add('is-paused');
    });
    root.addEventListener('shopify:block:deselect', function () { root.classList.remove('is-paused'); });
    show(0);

    // Число товаров у брендов: фильтры коллекции доступны только на её странице,
    // поэтому берём их лёгким запросом к служебной секции.
    var brands = root.querySelector('[data-look-counts]');
    if (brands && window.fetch) {
      window.fetch(brands.getAttribute('data-look-counts'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html.match(/<script[^>]*data-dune-vendor-counts[^>]*>([\s\S]*?)<\/script>/);
          if (!m) return;
          var counts = JSON.parse(m[1]);
          brands.querySelectorAll('[data-look-vendor]').forEach(function (a) {
            var n = counts[a.getAttribute('data-look-vendor')];
            if (!n || a.querySelector('i')) return;
            var i = document.createElement('i');
            i.textContent = n;
            a.appendChild(i);
          });
        })
        .catch(function () {});
    }
  }

  /* --- 13. Песок в футере ------------------------------------------------ */
  // Canvas-слой под контентом футера. Песчинки летят порывами слева направо (внизу гуще),
  // внизу низкая дюна: точечная насыпь, тонкая линия профиля и направляющая по вершине.
  // Ветер огибает дюну, часть песчинок ложится на склон; с гребня в сильный порыв
  // срываются редкие точки. Рисует только пока футер в экране и вкладка активна;
  // при prefers-reduced-motion один статичный кадр.
  // Прототип с вариантами: https://claude.ai/artifact/SoDYKAiXgYvRA8hPpuh3mj
  var SAND = ['#d8d2c4', '#c7bfaf', '#b1a794', '#978c78', '#dec400'];

  function sandHash(ix, iy) {
    var n = (Math.imul(ix, 374761393) + Math.imul(iy, 668265263)) | 0;
    n = Math.imul(n ^ (n >>> 13), 1274126177);
    n ^= n >>> 16;
    return (n >>> 0) / 4294967296;
  }
  function sandNoise(x, y) {
    var ix = Math.floor(x), iy = Math.floor(y), fx = x - ix, fy = y - iy;
    var sx = fx * fx * (3 - 2 * fx), sy = fy * fy * (3 - 2 * fy);
    var a = sandHash(ix, iy), b = sandHash(ix + 1, iy), c = sandHash(ix, iy + 1), d = sandHash(ix + 1, iy + 1);
    var t = a + (b - a) * sx, u = c + (d - c) * sx;
    return t + (u - t) * sy;
  }

  function initSand(cv) {
    if (cv.duneSand || !cv.getContext || !window.requestAnimationFrame) return;
    cv.duneSand = true;
    var ftr = cv.parentNode;
    var ctx = cv.getContext('2d');
    if (!ftr || !ctx) return;
    var opt = {
      strength: parseFloat(cv.getAttribute('data-strength')) || 1,
      yellow: cv.getAttribute('data-yellow') === 'true',
      cursor: cv.getAttribute('data-cursor') === 'true' && hoverable,
      dune: cv.getAttribute('data-dune') || 'none',
      height: parseFloat(cv.getAttribute('data-height')) || 0.65,
      wisp: cv.getAttribute('data-wisp') === 'true',
      guide: cv.getAttribute('data-guide') === 'true'
    };
    var W = 0, H = 0, DPR = 1, T = 0, last = 0, raf = 0, running = false, visible = false, gust = 0;
    var ptr = { x: -1e4, y: -1e4, vx: 0, vy: 0, t: 0, on: false };
    var grains = [], wisps = [], acc = 0, body = null, base = 0, bumps = [];

    /* ветер в px/s, дует слева направо; gust 0..1 — текущий порыв */
    function windNow(t) {
      var g = Math.max(0, (sandNoise(t * 0.11, 7.3) - 0.38) / 0.62);
      gust = g * g;
      return (55 + gust * 260) * opt.strength;
    }
    function turb(x, y, t) {
      return [(sandNoise(x * 0.005 + t * 0.06, y * 0.005) - 0.5) * 2, (sandNoise(x * 0.005 + 50, y * 0.005 + t * 0.08) - 0.5) * 2];
    }
    function cursorWind(x, y) {
      if (!opt.cursor || !ptr.on) return [0, 0];
      var dx = x - ptr.x, dy = y - ptr.y, d2 = dx * dx + dy * dy, r = 170;
      if (d2 > r * r) return [0, 0];
      var f = (1 - Math.sqrt(d2) / r) * 0.6;
      return [ptr.vx * f, ptr.vy * f];
    }
    function colorFor(z) {
      if (opt.yellow && Math.random() < 0.016) return 4;
      return z < 0.55 ? 0 : z < 0.8 ? 1 : z < 1.05 ? 2 : 3;
    }
    function eff(p) {
      if (p.life === undefined) return p.c;
      var k = Math.floor((p.age / p.life) * 3);
      return p.c === 4 ? (k >= 2 ? 1 : 4) : Math.max(0, p.c - k);
    }
    function compact(list) {
      var j = 0;
      for (var i = 0; i < list.length; i++) if (!list[i].dead) list[j++] = list[i];
      list.length = j;
    }
    /* точки по цветам: медленные квадратиком, быстрые короткой чертой */
    function drawGrains(list, sk) {
      for (var ci = 0; ci < 5; ci++) {
        var has = false;
        ctx.fillStyle = SAND[ci]; ctx.strokeStyle = SAND[ci]; ctx.lineWidth = 1;
        ctx.beginPath();
        for (var i = 0; i < list.length; i++) {
          var p = list[i];
          if (p.dead || eff(p) !== ci) continue;
          var sp = Math.abs(p.vx) + Math.abs(p.vy);
          if (sk && sp > 160) {
            var L = Math.min(18, sp * sk), inv = L / sp;
            ctx.moveTo(p.x - p.vx * inv, p.y - p.vy * inv);
            ctx.lineTo(p.x, p.y);
            has = true;
          } else {
            ctx.fillRect(p.x, p.y, p.s, p.s);
          }
        }
        if (has) ctx.stroke();
      }
    }

    /* профиль дюны: пологий наветренный склон слева, крутой подветренный справа */
    function surf(x) {
      var y = base;
      for (var i = 0; i < bumps.length; i++) {
        var b = bumps[i], d = x - b.c, w = d < 0 ? b.wl : b.wr;
        y -= b.a * Math.exp(-(d * d) / (w * w));
      }
      return y;
    }
    function lee(x) { return surf(x + 3) > surf(x - 3) + 0.3; }
    function buildBody() {
      var b = document.createElement('canvas');
      b.width = Math.max(1, Math.round(W * DPR)); b.height = Math.max(1, Math.round(H * DPR));
      var bc = b.getContext('2d');
      bc.scale(DPR, DPR);
      var soft = opt.dune !== 'band';
      bc.globalAlpha = soft ? 0.55 : 1;
      var buckets = [[], [], [], []], top = base, x, y, d, p, ci, i;
      for (x = 0; x < W; x += 1) {
        var sy = surf(x), depth = base - sy, isLee = lee(x);
        if (sy < top) top = sy;
        for (d = 0; d < depth; d += 1.3) {
          p = 0.38 * Math.exp(-d / 40) + 0.05 * Math.exp(-d / 140);
          if (isLee) p *= 1.6;
          if (Math.random() < p) {
            ci = d < 5 ? (Math.random() < 0.35 ? 3 : 2) : (Math.random() < 0.5 ? 1 : 0);
            if (isLee && Math.random() < 0.5) ci = Math.min(3, ci + 1);
            buckets[ci].push(x + Math.random() * 0.8, sy + d, d < 5 ? 0.9 : 0.7);
          }
        }
      }
      for (ci = 0; ci < 4; ci++) {
        bc.fillStyle = SAND[ci];
        var arr = buckets[ci];
        for (i = 0; i < arr.length; i += 3) bc.fillRect(arr[i], arr[i + 1], arr[i + 2], arr[i + 2]);
      }
      if (opt.guide) {
        bc.globalAlpha = 1; bc.strokeStyle = '#e5e3de'; bc.lineWidth = 1;
        bc.beginPath(); bc.moveTo(0, Math.round(top) + 0.5); bc.lineTo(W, Math.round(top) + 0.5); bc.stroke();
      }
      bc.globalAlpha = soft ? 0.75 : 1;
      bc.strokeStyle = '#9b917e'; bc.lineWidth = 1;
      bc.beginPath();
      var open = false;
      for (x = 0; x <= W; x += 2) {
        y = surf(x);
        if (y < base - 0.7) { open ? bc.lineTo(x, y) : bc.moveTo(x, y); open = true; }
        else open = false;
      }
      bc.stroke();
      return b;
    }

    function spawn(any) {
      var z = 0.35 + Math.random() * 0.95;
      var p = { x: any ? Math.random() * W : -6, y: H * Math.sqrt(Math.random()), z: z, s: 0.6 + z * 1.1, c: colorFor(z), vx: 0, vy: 0 };
      if (bumps.length) {
        var sy = surf(p.x);
        if (p.y > sy - 2) p.y = Math.random() * Math.max(10, sy - 4);
      }
      return p;
    }
    function newWisp(Wd) {
      var b = bumps[0], z = 0.5 + Math.random() * 0.6;
      var x = b.c - Math.random() * Math.random() * b.wl * 0.25;
      return { x: x, y: surf(x) - 1, z: z, s: 0.6 + Math.random() * 0.5, c: Math.random() < 0.6 ? 0 : 1, vx: Wd * z * 0.5, vy: -(8 + Math.random() * 25), age: 0, life: 1.5 + Math.random() * 1.6 };
    }

    function setup() {
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      W = ftr.clientWidth; H = ftr.clientHeight;
      cv.width = Math.max(1, Math.round(W * DPR)); cv.height = Math.max(1, Math.round(H * DPR));
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      var oy = ftr.getBoundingClientRect().top + ftr.clientTop;
      var rule = ftr.querySelector('[data-dune-sand-rule]');
      var band = ftr.querySelector('[data-dune-sand-band]');
      var amp = 0;
      bumps = [];
      if (opt.dune === 'band' && band) {
        var br = band.getBoundingClientRect();
        base = br.bottom - oy - 1;
        amp = br.height * 0.92 * (0.55 + 0.45 * opt.height);
      } else if (opt.dune !== 'none' && rule) {
        base = rule.getBoundingClientRect().top - oy - 1;
        amp = Math.max(60, Math.min(140, H * 0.15)) * opt.height;
        // на телефоне колонки меню сложены в аккордеон, дюна за ним ниже
        if (W < 760) amp *= 0.6;
      } else {
        base = H + 60;
      }
      if (amp > 0) {
        bumps = opt.dune === 'right'
          ? [{ c: W * 0.8, wl: W * 0.2, wr: W * 0.055, a: amp }, { c: W * 0.56, wl: W * 0.09, wr: W * 0.035, a: amp * 0.32 }]
          : [{ c: W * 0.6, wl: W * 0.3, wr: W * 0.075, a: amp }, { c: W * 0.17, wl: W * 0.16, wr: W * 0.05, a: amp * 0.42 }, { c: W * 0.9, wl: W * 0.09, wr: W * 0.035, a: amp * 0.33 }];
      }
      body = bumps.length ? buildBody() : null;
      wisps = []; acc = 0;
      var n = Math.max(120, Math.min(2600, Math.round(W * H / 2600 * opt.strength)));
      grains = [];
      for (var i = 0; i < n; i++) grains.push(spawn(true));
    }

    function step(dt, t, Wd) {
      var k = Math.min(1, dt * 5), i, p, tt, cw;
      for (i = 0; i < grains.length; i++) {
        p = grains[i];
        tt = turb(p.x, p.y, t); cw = cursorWind(p.x, p.y);
        var lx = Wd * p.z * (0.7 + tt[0] * 0.5) + cw[0];
        var ly = tt[1] * (20 + gust * 60) * p.z + 10 * p.z + cw[1];
        if (bumps.length) {
          var lift = surf(p.x) - 14 - p.y;
          if (lift < 0) ly += lift * 1.5 * p.z;
        }
        p.vx += (lx - p.vx) * k; p.vy += (ly - p.vy) * k;
        p.x += p.vx * dt; p.y += p.vy * dt;
        if (bumps.length) {
          var sy = surf(p.x);
          if (p.y >= sy - 1) {
            if (Math.random() < 0.5) { grains[i] = spawn(false); continue; }
            p.y = sy - 1.5; p.vy = -15;
          }
        }
        if (p.x > W + 6) grains[i] = spawn(false);
        else if (p.x < -8) p.x = W + 6;
        if (p.y > H + 6) p.y = -4; else if (p.y < -6) p.y = H + 4;
      }
      if (!bumps.length) return;
      if (opt.wisp && gust > 0.3) {
        acc += (gust - 0.3) * 90 * opt.strength * dt;
        while (acc > 1 && wisps.length < 320) { acc--; wisps.push(newWisp(Wd)); }
      }
      var kw = Math.min(1, dt * 2);
      for (i = 0; i < wisps.length; i++) {
        p = wisps[i];
        p.age += dt;
        if (p.age > p.life) { p.dead = true; continue; }
        tt = turb(p.x, p.y, t); cw = cursorWind(p.x, p.y);
        p.vx += (Wd * p.z * (0.5 + tt[0] * 0.3) + cw[0] - p.vx) * kw;
        p.vy += (tt[1] * 25 - 12 * (1 - p.age / p.life) + cw[1] - p.vy) * kw + 20 * dt;
        p.x += p.vx * dt; p.y += p.vy * dt;
        if (p.x > W + 5 || p.y >= surf(p.x)) p.dead = true;
      }
      compact(wisps);
    }
    function render() {
      ctx.clearRect(0, 0, W, H);
      if (body) ctx.drawImage(body, 0, 0, W, H);
      drawGrains(grains, 0.028);
      if (wisps.length) drawGrains(wisps, 0);
    }

    function frame(ts) {
      raf = 0;
      if (!running) return;
      if (!cv.isConnected) { running = false; return; }
      var dt = Math.min(0.05, (ts - last) / 1000 || 0.016);
      last = ts; T += dt;
      var Wd = windNow(T);
      var dec = Math.exp(-dt * 6);
      ptr.vx *= dec; ptr.vy *= dec;
      step(dt, T, Wd);
      render();
      raf = requestAnimationFrame(frame);
    }
    function start() {
      if (reduced || !visible || document.hidden || running || !cv.isConnected) return;
      running = true;
      last = performance.now();
      if (!raf) raf = requestAnimationFrame(frame);
    }
    function stop() { running = false; }
    function reinit() {
      setup();
      if (reduced) {
        for (var i = 0; i < 180; i++) { T += 1 / 60; step(1 / 60, T, windNow(T)); }
        render();
      } else {
        render();
        start();
      }
    }

    if (opt.cursor) {
      ftr.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        var fr = ftr.getBoundingClientRect();
        var x = e.clientX - fr.left - ftr.clientLeft, y = e.clientY - fr.top - ftr.clientTop, now = performance.now();
        if (ptr.on) {
          var dt = Math.max(0.004, (now - ptr.t) / 1000);
          ptr.vx = Math.max(-2500, Math.min(2500, ptr.vx * 0.5 + (x - ptr.x) / dt * 0.5));
          ptr.vy = Math.max(-2500, Math.min(2500, ptr.vy * 0.5 + (y - ptr.y) / dt * 0.5));
        }
        ptr.x = x; ptr.y = y; ptr.t = now; ptr.on = true;
      });
      ftr.addEventListener('pointerleave', function () { ptr.on = false; ptr.vx = ptr.vy = 0; });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        visible ? start() : stop();
      }, { threshold: 0.02 }).observe(ftr);
    } else {
      visible = true;
    }
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    if ('ResizeObserver' in window) {
      var rt = 0;
      new ResizeObserver(function () {
        if (ftr.clientWidth === W && ftr.clientHeight === H) return;
        clearTimeout(rt);
        rt = setTimeout(reinit, 150);
      }).observe(ftr);
    }
    reinit();
  }

  /* --- 14. Кольори в картці товару ------------------------------------------ */

  // Наведення на міні-плашку кольору показує фото цього кольору на місці фото картки,
  // поки курсор у ряду плашок. Фото спершу вантажиться окремо, тож поточне не блимає.
  // Картки приходять і після завантаження (фільтри, «Вас може зацікавити»): події на документі.
  function colorPreview(card, swatch) {
    var link = card.querySelector('.product-item__image-link');
    if (!link) return;
    var layer = link.querySelector('.dune-card__preview');
    var srcset = swatch ? swatch.getAttribute('data-dune-color-srcset') : null;
    card.duneColor = srcset;
    // ряд розмірів і «+» належать поточному товару: поки видно інший колір, вони сховані
    card.classList.toggle('is-color-preview', !!srcset);
    if (!srcset) {
      if (layer) layer.classList.remove('is-on');
      return;
    }
    var main = link.querySelector('.product-item__image img');
    if (!layer) {
      layer = document.createElement('span');
      layer.className = 'dune-card__preview';
      layer.setAttribute('aria-hidden', 'true');
      layer.appendChild(document.createElement('img'));
      link.appendChild(layer);
    }
    var img = layer.firstChild;
    var sizes = (main && main.getAttribute('sizes')) || '50vw';
    if (main) {
      var cs = getComputedStyle(main);
      img.style.objectFit = cs.objectFit;
      img.style.objectPosition = cs.objectPosition;
    }
    var show = function () {
      if (card.duneColor !== srcset) return;
      if (img.getAttribute('srcset') !== srcset) {
        img.sizes = sizes;
        img.srcset = srcset;
      }
      layer.classList.add('is-on');
    };
    if (img.getAttribute('srcset') === srcset) return show();
    var pre = new Image();
    pre.sizes = sizes;
    pre.srcset = srcset;
    if (pre.complete && pre.naturalWidth) show();
    else pre.onload = show;
  }
  function colorRowLeave(e) {
    var row = e.target.closest ? e.target.closest('[data-dune-card-colors]') : null;
    if (!row || (e.relatedTarget && row.contains(e.relatedTarget))) return;
    var card = row.closest('.dune-card');
    if (card) colorPreview(card, null);
  }
  function colorRowEnter(e) {
    var swatch = e.target.closest ? e.target.closest('.dune-card__color') : null;
    var card = swatch && swatch.closest('.dune-card');
    if (card) colorPreview(card, swatch);
  }
  var canHover = window.matchMedia('(hover: hover)');
  document.addEventListener('mouseover', function (e) { if (canHover.matches) colorRowEnter(e); });
  document.addEventListener('mouseout', colorRowLeave);
  document.addEventListener('focusin', colorRowEnter);
  document.addEventListener('focusout', colorRowLeave);

  /* --- 15. Кольори на сторінці товару ---------------------------------------- */

  // Коли кольорів більше, ніж влазить в ряд, блок не росте в кілька рядів.
  // «Стрічка» гортається стрілками, пальцем чи тачпадом; «Один ряд» показує ряд
  // із поточним кольором, решта з'являється за кнопкою «Усі кольори».
  var colorSyncs = [];
  function colorsStrip(el, list) {
    var thumb = el.querySelector('.dune-colors__thumb');
    var sync = function () {
      var max = list.scrollWidth - list.clientWidth;
      var x = list.scrollLeft;
      el.classList.toggle('is-overflow', max > 1);
      list.style.setProperty('--dune-fade-l', x > 1 ? '28px' : '0px');
      list.style.setProperty('--dune-fade-r', x < max - 1 ? '28px' : '0px');
      el.querySelectorAll('[data-dune-colors-step]').forEach(function (btn) {
        var dir = parseInt(btn.getAttribute('data-dune-colors-step'), 10);
        btn.setAttribute('aria-disabled', dir < 0 ? x <= 1 : x >= max - 1);
      });
      if (thumb && list.scrollWidth) {
        thumb.style.width = (list.clientWidth / list.scrollWidth * 100) + '%';
        thumb.style.transform = 'translateX(' + (x / list.clientWidth * 100) + '%)';
      }
    };
    list.addEventListener('scroll', sync, { passive: true });
    el.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dune-colors-step]');
      if (!btn) return;
      var dir = parseInt(btn.getAttribute('data-dune-colors-step'), 10);
      list.scrollBy({ left: dir * Math.max(list.clientWidth * 0.75, 80), behavior: reduced ? 'auto' : 'smooth' });
    });
    // поточний колір одразу в полі зору, ближче до середини
    var cur = list.querySelector('.is-current');
    if (cur) list.scrollLeft = cur.offsetLeft - (list.clientWidth - cur.offsetWidth) / 2;
    sync();
    return sync;
  }
  function colorsFold(el, list) {
    var btn = el.querySelector('[data-dune-colors-toggle]');
    var items = [].slice.call(list.querySelectorAll('.dune-colors__item'));
    var open = false;
    var apply = function (animate) {
      items.forEach(function (it) {
        it.classList.remove('is-folded', 'is-arriving');
        it.style.animationDelay = '';
      });
      var top = items[0].offsetTop;
      var perRow = 0;
      while (perRow < items.length && items[perRow].offsetTop === top) perRow++;
      var over = perRow < items.length;
      el.classList.toggle('is-overflow', over);
      el.classList.add('is-ready');
      if (btn) {
        btn.hidden = !over;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Згорнути' : 'Усі кольори';
      }
      if (!over) return;
      if (open) {
        if (animate) {
          items.forEach(function (it, i) {
            if (i < perRow) return;
            it.classList.add('is-arriving');
            it.style.animationDelay = (i - perRow) * 25 + 'ms';
          });
        }
        return;
      }
      // у згорнутому ряду завжди є поточний колір: він стає на місце останнього
      var cur = items.indexOf(list.querySelector('.is-current'));
      items.forEach(function (it, i) {
        var keep = i < perRow - 1 || (i === perRow - 1 && cur < perRow) || i === cur;
        it.classList.toggle('is-folded', !keep);
      });
    };
    if (btn) btn.addEventListener('click', function () { open = !open; apply(true); });
    apply(false);
    return function () { apply(false); };
  }
  function initColors(el) {
    var list = el.querySelector('[data-dune-colors-list]');
    if (!list || el.duneColors) return;
    el.duneColors = true;
    colorSyncs.push(el.getAttribute('data-dune-colors') === 'fold' ? colorsFold(el, list) : colorsStrip(el, list));
  }
  var colorsResize = null;
  window.addEventListener('resize', function () {
    clearTimeout(colorsResize);
    colorsResize = setTimeout(function () { colorSyncs.forEach(function (fn) { fn(); }); }, 150);
  });

  /* --- Ghost-сканер (snippets/dune-ghost.liquid) ------------------------- */
  // Карточка: один проход при появлении в окне и проход при наведении мышью (класс is-sweep,
  // анимация в custom.css). Страница: проход идёт циклом в CSS, здесь — пятно вокруг
  // курсора и пауза, пока секция вне экрана.
  var ghostReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ghostHoverCard = null;
  function ghostSweep(el) {
    if (ghostReduce) return;
    el.classList.remove('is-sweep');
    void el.offsetWidth; // перезапуск анимации
    el.classList.add('is-sweep');
  }
  var ghostIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var el = en.target;
      if (el.getAttribute('data-dune-ghost') === 'page') {
        el.classList.toggle('is-off', !en.isIntersecting);
        return;
      }
      if (en.intersectionRatio < 0.6) return;
      ghostIO.unobserve(el);
      setTimeout(function () { ghostSweep(el); }, 200 + Math.random() * 500);
    });
  }, { threshold: [0, 0.6] }) : null;
  // Компас страницы — в перекрестье между фото галереи: за колонкой покупки его не видно.
  // Страницы галереи сдвигаются целиком, поэтому точка считается от рамки и первой плашки.
  // Галерея в одну колонку (телефон, одно фото) — компас остаётся на месте из CSS.
  function ghostPlaceRose(el, host) {
    var frame = host.querySelector('.dune-gal__frame');
    var item = frame && frame.querySelector('.dune-gal__item');
    var fr = frame && frame.getBoundingClientRect();
    var ir = item && item.getBoundingClientRect();
    if (!ir || !ir.width || ir.width > fr.width * 0.6) {
      el.classList.remove('is-placed');
      return;
    }
    var page = item.parentNode;
    var gap = parseFloat(getComputedStyle(page).columnGap) || 8;
    var lr = el.getBoundingClientRect();
    var twoRows = page.querySelectorAll('.dune-gal__item').length > 2;
    el.style.setProperty('--dune-rose-x', (fr.left - lr.left + ir.width + gap / 2) + 'px');
    el.style.setProperty('--dune-rose-y', (fr.top - lr.top + (twoRows ? ir.height + gap / 2 : ir.height / 2)) + 'px');
    el.classList.add('is-placed');
  }
  function initGhost(el) {
    if (el.duneGhost) return;
    el.duneGhost = true;
    if (ghostIO) ghostIO.observe(el);
    if (el.getAttribute('data-dune-ghost') !== 'page') return;
    var host = el.parentNode, raf = null, mx = -9999, my = -9999;
    ghostPlaceRose(el, host);
    window.addEventListener('resize', function () { ghostPlaceRose(el, host); });
    window.addEventListener('load', function () { ghostPlaceRose(el, host); });
    host.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var r = el.getBoundingClientRect();
      mx = e.clientX - r.left;
      my = e.clientY - r.top;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        el.style.setProperty('--dune-mx', mx + 'px');
        el.style.setProperty('--dune-my', my + 'px');
      });
    });
    host.addEventListener('pointerleave', function () {
      el.style.setProperty('--dune-mx', '-9999px');
      el.style.setProperty('--dune-my', '-9999px');
    });
  }
  // Наведение и конец прохода — делегированием: сетку листинга тема перерисовывает при фильтрах.
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var card = e.target.closest ? e.target.closest('.product-item') : null;
    if (!card || card === ghostHoverCard) return;
    ghostHoverCard = card;
    var el = card.querySelector('[data-dune-ghost="card"]');
    if (el) ghostSweep(el);
  });
  document.addEventListener('pointerout', function (e) {
    var card = e.target.closest ? e.target.closest('.product-item') : null;
    if (card && card === ghostHoverCard && !card.contains(e.relatedTarget)) ghostHoverCard = null;
  });
  document.addEventListener('animationend', function (e) {
    if (e.animationName !== 'dune-ghost-sweep') return;
    var el = e.target.closest ? e.target.closest('.dune-ghost') : null;
    if (el) el.classList.remove('is-sweep');
  });
  // Новые карточки после фильтра или подгрузки — тем же наблюдателем появления.
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('[data-dune-ghost]')) initGhost(n);
          else if (n.querySelectorAll) n.querySelectorAll('[data-dune-ghost]').forEach(initGhost);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* --- 16. Подсказка в поле печатается по буквам ------------------------- */
  // Полоса подписки в футере (sections/dune-footer.liquid): фразы из data-lines печатаются
  // и стираются по очереди, за ними жёлтый блок-курсор. Пока поле видно на экране.
  // Карточка подписки (dune-signup) печатает свою подсказку сама, в assets/dune-signup.js.

  function initType(el) {
    if (el.duneType) return;
    el.duneType = true;
    var field = el.parentNode;
    var input = field.querySelector('input[type="email"]');
    var out = el.querySelector('[data-dune-type-text]');
    var lines = [];
    try {
      lines = JSON.parse(el.getAttribute('data-lines')).map(function (s) { return s.trim(); }).filter(Boolean);
    } catch (e) {}
    if (!input || !out || !lines.length) return;
    field.classList.add('is-typing');
    var sync = function () { field.classList.toggle('is-filled', input.value !== ''); };
    input.addEventListener('input', sync);
    sync();
    if (reduced) {
      out.textContent = lines[0];
      return;
    }
    var li = 0, ci = 0, dir = 1, t = 0, on = false;
    function tick() {
      if (!on) return;
      var line = lines[li];
      ci += dir;
      out.textContent = line.slice(0, ci);
      el.classList.add('is-busy');
      var wait = dir > 0 ? 55 + Math.random() * 70 : 26;
      if (dir > 0 && ci >= line.length) {
        dir = -1; wait = 1800; el.classList.remove('is-busy');
      } else if (dir < 0 && ci <= 0) {
        dir = 1; li = (li + 1) % lines.length; wait = 400; el.classList.remove('is-busy');
      }
      t = setTimeout(tick, wait);
    }
    var io = new IntersectionObserver(function (entries) {
      var vis = entries[0].isIntersecting;
      if (vis && !on) { on = true; t = setTimeout(tick, 300); }
      else if (!vis && on) { on = false; clearTimeout(t); }
    });
    io.observe(field);
  }

  /* --- 17. Instagram: лента из CRM -------------------------------------- */

  // Список готовит CRM (модуль Odoo flux_insta_feed): { photos: [{ img, link, alt }] }.
  // Запрос уходит, когда секция подходит к экрану: она в подвале каждой страницы.
  // Плашки в разметке держат сетку, пока фото не пришли; не пришли совсем — лента прячется.
  function initInsta(box) {
    if (box.__duneInsta) return;
    box.__duneInsta = true;
    var grid = box.querySelector('[data-insta-grid]');
    var count = parseInt(box.getAttribute('data-count'), 10) || 10;
    var url = box.getAttribute('data-dune-insta');
    if (!grid || !url) return;

    function fill(photos) {
      if (!photos.length) { box.classList.add('is-failed'); return; }
      var tiles = grid.children;
      for (var i = 0; i < tiles.length; i++) {
        var li = tiles[i], p = photos[i];
        if (!p) { li.hidden = true; continue; }
        li.classList.remove('is-empty');
        li.removeAttribute('aria-hidden');
        var a = document.createElement('a');
        a.href = p.link;
        a.target = '_blank';
        a.rel = 'noopener';
        a.setAttribute('aria-label', p.alt ? 'Instagram: ' + p.alt : 'Публікація в Instagram');
        var img = new Image();
        img.alt = p.alt || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 640;
        img.height = 640;
        img.onload = function () { this.classList.add('is-loaded'); };
        img.src = p.img;
        a.appendChild(img);
        li.appendChild(a);
      }
    }

    function load() {
      var sep = url.indexOf('?') < 0 ? '?' : '&';
      fetch(url + sep + 'n=' + count, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) { fill((d && d.photos) || []); })
        .catch(function () { box.classList.add('is-failed'); });
    }

    if (!('IntersectionObserver' in window)) { load(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      load();
    }, { rootMargin: '800px 0px' });
    io.observe(box);
  }

  /* --- Запуск ------------------------------------------------------------ */

  function init(root) {
    (root || document).querySelectorAll('[data-dune-gallery]').forEach(initGallery);
    (root || document).querySelectorAll('[data-dune-panel]').forEach(initPanel);
    (root || document).querySelectorAll('[data-dune-reveal]').forEach(initReveal);
    (root || document).querySelectorAll('[data-collection-columns-desktop], [data-dune-cols-default]').forEach(initCols);
    (root || document).querySelectorAll('[data-dune-brand-index]').forEach(initBrandIndex);
    (root || document).querySelectorAll('[data-dune-hours]').forEach(initHours);
    (root || document).querySelectorAll('[data-dune-doc]').forEach(initDoc);
    (root || document).querySelectorAll('[data-dune-stage]').forEach(initStage);
    (root || document).querySelectorAll('[data-dune-brand-belt]').forEach(initBrandBelt);
    (root || document).querySelectorAll('[data-dune-looks]').forEach(initLooks);
    (root || document).querySelectorAll('[data-dune-fit]').forEach(fitTitle);
    (root || document).querySelectorAll('[data-dune-sand]').forEach(initSand);
    (root || document).querySelectorAll('[data-dune-colors]').forEach(initColors);
    (root || document).querySelectorAll('[data-dune-ghost]').forEach(initGhost);
    (root || document).querySelectorAll('[data-dune-type]').forEach(initType);
    (root || document).querySelectorAll('[data-dune-insta]').forEach(initInsta);
    syncFooterFolds();
    syncStickyTop();
    syncChatLift();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Редактор тем перерисовывает секции без перезагрузки страницы.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
